import React from 'react';
import Price from "../Price";
import { useLingui } from '@lingui/react/macro';
import { useSelector } from 'react-redux';
import { getExcursionText } from '../../utils/themeUtils';
import capitalize from 'lodash/capitalize';

function CartElementConfirmation(props) {
    const currencySymbol = useSelector((state)=>state.bookings.currencySymbol);

    const {t} = useLingui();

    const excursionText = getExcursionText();
    const pricePreText =
        props.status === "Waitlisted"
            ? capitalize(t({ id: "excursion_cost_if_confirmed", message: `${excursionText} cost if confirmed`}))
            : "";
    
    return (
        <div className="mt-4 border-b print-border-0">
            <div className="sm:flex sm:justify-between sm:items-end pb-2">
                <div>
                    <div className="sm:flex sm:items-baseline sm:flex-wrap">
                        <div className="text-primary-dark text-lg sm:mr-2">{props.title}</div>

                        {props.subtitle &&
                            <div>{props.subtitle}</div>
                        }
                    </div>

                    <div className="mt-1">
                        {props.day}
                    </div>
                    <div className="mt-1">
                        {props.time}
                    </div>
                    <div className="mt-1">
                        {props.people}
                    </div>
                </div>
                <div className="text-right">
                    {props.status === "Waitlisted" &&
                    <div>
                        <Price classes="sm:leading-negative mb-2" preText={t({id: "waitlist_cost"})} price={0} currencySymbol={currencySymbol}/>
                    </div>
                    }
                    <Price preText={pricePreText} price={props.price} currencySymbol={currencySymbol} strikethrough={props.strikePrice}/>
                </div>
            </div>
        </div>
    );
}

export default CartElementConfirmation;